module.exports = __webpack_public_path__ + "static/media/zym-details.31b2782a.jpg";